import { Box, Card, List } from '@material-ui/core';
import React, { useState } from 'react';
import './style.css';

enum GeneralTabsIds {
  All = 'all',
  Standard = 'standard',
  ThreeMonth = '3month',
  SixMonth = '6month',
  TwelveMonth = '12month',
}
const Tabs = [
  {
    title: 'All',
    id: GeneralTabsIds.All,
  },
  {
    title: 'Standard',
    id: GeneralTabsIds.Standard,
  },
  {
    title: '3 Month',
    id: GeneralTabsIds.ThreeMonth,
  },
  {
    title: '6 Month',
    id: GeneralTabsIds.SixMonth,
  },
  {
    title: '12 Month',
    id: GeneralTabsIds.TwelveMonth,
  },
];
const SubscriptionStatisticTabs = (props) => {
  const [currentTabId, setCurrentTabId] = useState<string>(GeneralTabsIds.All);

  return (
    <Box className='subscription-statistic-tabs-wrapper'>
      <Box className='subscription-statistic-tabs-head'>
        <List disablePadding={true}>
          {Tabs.map((i, index) => {
            return (
              <Box onClick={() => setCurrentTabId(i.id)} key={index}>
                <div
                  className={`subscription-statistic-tab ${
                    i.id === currentTabId ? 'active' : ''
                  }`}
                >
                  {i.title}
                </div>
              </Box>
            );
          })}
        </List>
      </Box>
      <Box className='subscription-statistic-tabs-panels'>
        {props.tabs.map((tab, index) => {
          return (
            <SubscriptionStatisticPanel
              key={tab.value}
              tab={GeneralTabsIds.Standard}
              selected={currentTabId}
              value={tab.value}
              index={index}
            >
              <Box>{tab.panel}</Box>
            </SubscriptionStatisticPanel>
          );
        })}
      </Box>
    </Box>
  );
};

const SubscriptionStatisticPanel = (props) => {
  const { selected, value, index, children, ...other } = props;
  return (
    <Box
      role='tabpanel'
      hidden={selected !== value}
      className='subscription-statistic-tabs-panel'
      {...other}
    >
      {selected === value && children}
    </Box>
  );
};
export {
  SubscriptionStatisticTabs,
  GeneralTabsIds,
  Tabs,
  SubscriptionStatisticPanel,
};
